import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DoubleRingPieService } from './double-ring-pie.service';
import { ECharts, EChartOption, EChartTitleOption } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChartResizeService } from '../../service/chart-resize.service';
import { CommonService } from '../../service/common.service';
import { ChartOptionService } from '../../service/chart-option.service';

@Component({
  selector: 'bcac-double-ring-pie',
  templateUrl: './double-ring-pie.component.html',
  styleUrls: ['./double-ring-pie.component.scss']
})
export class DoubleRingPieComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private doubleRingPieService: DoubleRingPieService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  }

  // 布局设置
  // cardPadding
  cardPadding = "1rem";
  cardBgColor = "#FFF";
  chartTitleColor = "";

  // echarts图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.doubleRingPieService.getDefaultChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartTextStyle = this.chartOptionService.getTextStyle();
  pie1ChartSeries = this.doubleRingPieService.getOutSidePieSeries();  //外侧饼图
  pie2ChartSeries = this.doubleRingPieService.getInsidePieSeries();  //内测饼图
  chartSeriesList: EChartOption.SeriesPie[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    legend: this.chartLegend,
    title: this.chartTitles,
    series: this.chartSeriesList,
    color: this.chartColors,
    textStyle: this.chartTextStyle
  };

  initOpts = this.chartOptionService.getInitOpts();
  echartInstance: ECharts;
  onOptionInit(ec) {
    this.echartInstance = ec;
  }

  options;
  //echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.options, true);
    }
  }

  @Input()
  set bcacDarkMode(darkMode: boolean) {
    if (darkMode == true) {
      this.doubleRingPieService.changeChartTitleDark(this, darkMode);  //修改标题暗色模式
      this.doubleRingPieService.chartBackgroundColorDarkMode(this.chartOption);  //修改图背景颜色
      this.doubleRingPieService.legendDarkMode(this.chartLegend);
      this.doubleRingPieService.colorsDarkMode(this.chartColors);  //修改图 颜色序列
      this.doubleRingPieService.seriesDarkMode(this.pie1ChartSeries)  //修改外饼图颜色
      this.doubleRingPieService.seriesDarkMode(this.pie2ChartSeries)  //修改内饼图颜色
      this.doubleRingPieService.chartTitleDarkMode(this.chartTitles) //修改标题颜色
    }
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.doubleRingPieService.setSmallModePadding(this);
    }
  }

  legendPosition = "bottom";
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.doubleRingPieService.setLegendPosition(this.chartLegend, legendPosition);
  }

  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.doubleRingPieService.chartColorsChange(this.chartColors, colorList);
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }


  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {

    let legendDataList = [];
    chartData.insideData.forEach(e => {
      legendDataList.push(
        {
          label: e.name,
          value: e.name,
          checked: true
        }
      );
    });
    chartData.outsideData.forEach(e => {
      legendDataList.push({
        label: e.name,
        value: e.name,
        checked: true
      })
    });
    this.legendDataList = legendDataList;
    this.doubleRingPieService.buildSeries(chartData, this.chartSeriesList, this.pie1ChartSeries, this.pie2ChartSeries)
    this.updateOption();
  }

  legendChange(e) {
    this.doubleRingPieService.topLegendChange(e, this.echartInstance)
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }
  // 修改内侧饼图的label连接线长度
  @Input()
  set bcacInsideLabelLength(length: number) {
    this.doubleRingPieService.setInsidePieLabelLength(length, this.pie2ChartSeries)
  }
  // 修改内侧饼图的label连接线2长度

  @Input()
  set bcacInsideLabelLength2(length2: number) {
    this.doubleRingPieService.setInsidePieLabelLength2(length2, this.pie2ChartSeries);
  }

  // 修改外侧饼图的label连接线2长度
  @Input()
  set bcacOutsideLabelLength(length: number) {
    this.doubleRingPieService.setOutsidePieLabelLength(length, this.pie1ChartSeries);
  }

  // 修改外侧饼图的label连接线2长度
  @Input()
  set bcacOutsideLabelLength2(length2: number) {
    this.doubleRingPieService.setOutsidePieLabelLength(length2, this.pie2ChartSeries);
  }
  // 修改内饼图半径
  @Input()
  set bcacInsideRadius(radius) {
    this.doubleRingPieService.setInsidePieRadius(radius, this.pie2ChartSeries);
  }
  // 修改外饼图半径
  @Input()
  set bcacOutsideRadius(radius) {
    this.doubleRingPieService.setOutsidePieRadius(radius, this.pie1ChartSeries);
  }

  @Input()
  set bcacInsideLabelType(type) {
    this.doubleRingPieService.setLabelType(type, this.pie2ChartSeries)
  }

  @Input()
  set bcacOutsideLabelType(type) {
    this.doubleRingPieService.setLabelType(type, this.pie1ChartSeries)
  }

  @Input()
  set bcacChartTitles(chartTitle: string) {
    this.doubleRingPieService.setChartTitle(chartTitle, this.chartTitles)
  }

  @Input()
  set bcacCenter(center) {
    this.doubleRingPieService.setPieCenter(center, this.pie1ChartSeries, this.pie2ChartSeries)
  }


  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoPieResizeAdapt(this.echartInstance, this.options)
    })
  }

}
